// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ReRc","header":"PatientBlock_header__zdMjb","label":"PatientBlock_label__2R-V0","option":"PatientBlock_option__2lMpC"};